import React from 'react'
import PageMidOneElements from './PageMidOneElements';
import { Box } from "@mui/material";
import page_mid_one_array from '../Arrays/page-mid-one-elements-array';

function createMidOneElements(elements) {
  return <PageMidOneElements 
  alt={elements.alt}
  img={elements.imgURL}
  img2={elements.imgURL2}
  text={elements.text}
  text2={elements.text2}
  text3={elements.text3}
  text4={elements.text4}
  />;
}

function PageMidOne () {
    return (
      <>
        <Box sx={{mb: "20px"}}>
          {page_mid_one_array.map(createMidOneElements)}
        </Box>
      </>

    );
};
export default PageMidOne;